<template>
  <Form
    :id="id"
    ref="filterForm"
    class="
      @768/layout/grid:2
      layout/grid:1
      layout/grid:gap:page
      layout/width:100%'
    "
    >
    <Select
      id="calendar-happening-filter"
      v-model="form.happening_filter"
      name="happening_filter"
      :options="optionGroups"
      aria-label="Filter by event type"
      @input="submitForm"
    />
    <DateInput
      id="calendar-happening-date"
      v-model="form.dateRaw"
      name="date"
      @change="onDateChange"
    />
  </Form>
</template>

<script>
  import Form from "../form/form";
  import Select from "../form/select";
  import DateInput from "../form/date";

  export default {
    components: { Form, Select, DateInput },
    props: {
      dateRaw: { type: Date, required: true },
      id: { type: String, required: true },
      option: { type: String, required: true },
      optionGroups: { type: Array, required: true }
    },
    data() {
      return {
        form: {
          happening_filter: this.option,
          date: this.dateRaw.toJSON().substring(0,10),
          dateRaw: this.dateRaw,
        }
      };
    },
    watch: {
      'form.dateRaw': function(newValue, oldValue) {
        this.form.date = newValue.toJSON().substring(0,10);
      }
    },
    methods: {
      submitForm() {
        this.$refs.filterForm.$el.submit();
      },
      onDateChange() {
        // TODO: FIX
        // the way it was submitting via `submit` event before was wrong
        // however, form worked but as a side effect
        this.$nextTick(() => {
          // Allow for watched value to update before submitting.
          this.submitForm();
        });
      }
    }
  };
</script>
